import { useTheme } from '../../context/ThemeContext';
import './theme-switcher.css';

function ThemeSwitcher() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const icon = isDark ? 'light_mode' : 'dark_mode';
  const label = isDark ? 'Ativar modo claro' : 'Ativar modo escuro';

  const className = `theme-switcher theme-switcher--compact ${isDark ? 'theme-switcher--dark' : 'theme-switcher--light'}`;

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={className}
      aria-pressed={isDark}
      aria-label={label}
      title={label}
    >
      <span className="material-symbols-outlined theme-switcher__icon">
        {icon}
      </span>
    </button>
  );
}

export default ThemeSwitcher;
